import { METHOD_TYPES } from 'utils/constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'

export const getPreviousRoundState = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'fast-games/cross-game/get-unfinished-bet-state', {}, {
    server: microServices.SERVICE_URL_1
  })
}

export const getBetHistory = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'fast-games/cross-game/get-bets', {}, {
    server: microServices.SERVICE_URL_1,
    params
  })
}

export const placeBet = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'fast-games/cross-game/place-bet', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const autoBet = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'fast-games/cross-game/auto-bet', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const openTile = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'fast-games/cross-game/open-tile', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const cashOutBet = () => {
  return axiosInstanceService(METHOD_TYPES.post, 'fast-games/cross-game/cash-out-bet', {}, {
    server: microServices.SERVICE_URL_1
  })
}

export const verifyProvableFairMine = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'fast-games/cross-game/check-provable-fair', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const getTopBets = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, '/fast-games/cross-game/top-bets', {}, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const getAllBets = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, '/fast-games/cross-game/all-bets', {}, {
    params,
    server: microServices.SERVICE_URL_1
  })
}
